export * from './extractURLDomainAndPath'
